import React, {useEffect, useMemo, useState} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {useDefaultEndpoints} from "../../../../lib/api/useDefaultEndpoints";
import {Loader} from "../../../generic/loader";
import {TableCard} from "../../../generic/cards";
import {Col, Label, Row} from "reactstrap";
import {FaPencilAlt} from 'react-icons/fa'

import MainInfo from "./MainInfo";
import ArrivalsTable from "./ArrivalsTable";

import {Promocodes} from "../../../bases/events/event/NewEventBlocks";
import {getPermissions} from "../../../../lib/utils/hooks/useRoleSystem";
import { onNewPage, onRoleEntity } from '../helpers';
import ExportByDirectionButton from '../../../common/formElements/ExportByDirectionButton';
import { COMMON_PRODUCT_DIRECTIONS } from '../../../../lib/utils/constants';
import {PRODUCT_TYPES} from "sv-common/constants/certificates";
import {CopyLink} from "../../../generic/buttons";
import {BOOKING_URL} from "../../../../lib/api/useApi";
import {t} from "i18next";

const AdventureView = ({createTranslatedBreadcrumbsAndTitle}) => {
    let history = useHistory();
    let {url} = useParams();
    const [state, setState] = useState({});
    let entity = useMemo(() => onRoleEntity(state.is_school, state.is_camp, state.is_kids, state.is_charter, state.type), [state.is_school, state.type, state.is_camp, state.is_kids, state.is_charter]);
    const {getEntries} = useDefaultEndpoints('adventures');
    const [isLoading, setLoading] = useState(true);
    const [typeForRule, setTypeForRule] = useState('');

    useEffect(() => {
        getEntries({url: url}).then(res => {
            const entry = res[0];
            setState(() => entry);
            const mapper = {
                url: {ru: entry.name, en: entry.url},
                type: {ru: entry.type === 'world' ? 'Мир' : 'Россия', en: entry.type}
            }

            if (!entry.is_camp && !entry.is_charter && !entry.is_school) {
                setTypeForRule(PRODUCT_TYPES.ARRIVALS);
            } else if (entry.is_school) {
                setTypeForRule(PRODUCT_TYPES.PRACTICES);
                mapper.type = {ru: entry.type === 'world' ? t('school.breadcrumbsAndTitle.practiceWorld') : t('school.breadcrumbsAndTitle.practiceRu'), en: entry.type};
            } else if (entry.is_charter) {
                setTypeForRule(PRODUCT_TYPES.CHARTERS);
            }

            createTranslatedBreadcrumbsAndTitle && createTranslatedBreadcrumbsAndTitle(mapper, mapper);
            setLoading(() => false);
        })// eslint-disable-next-line
    }, [history.location.pathname, url])

    const onEdit = () => {
      onNewPage(state.url, state.is_school, state.is_camp, state.is_kids, state.is_charter, true, history, state.type, true);
    }

    let copyLink;

    if (state.is_school) {
        copyLink = `${BOOKING_URL}/school/practice/${state.url}/`;
    } else if (state.is_charter) {
        copyLink = `${BOOKING_URL}/charter/${state.url}/`;
    } else {
        copyLink = `${BOOKING_URL}/travel/${state.url}/`;
    }

    return isLoading
        ? <Loader/>
        : <TableCard>

            <Row className={'mb-5 justify-content-between align-items-center'}>
                <Col className={'col-sm-auto col-12 flex-grow-1 col mb-3 mb-sm-0'}>
                    <div className={'display-4'}>
                        {state?.name} <FaPencilAlt style={{cursor: 'pointer'}} onClick={onEdit}
                    />
                    </div>
                    <Label for={'name'} className={'text-secondary'}>/{state.url}</Label>
                    <CopyLink href={copyLink} showLink={false}/>
                </Col>
            </Row>
            <Row className={'mb-5'}>
                <Col xs={12}>
                    <ArrivalsTable state={state} typeForRule={typeForRule} />
                </Col>
            </Row>

            <Row>
                <Col xs={12} md={6}>
                    <Row>
                        <Col xs={12}>
                            <MainInfo state={state}/>
                        </Col>
                        <Col xs={12}>
                          <ExportByDirectionButton direction={COMMON_PRODUCT_DIRECTIONS.ADVENTURES} directionId={state.id} />
                        </Col>
                    </Row>
                </Col>
                <Col xs={12} md={6}>
                    <Promocodes state={state} productType={'adventures'} disabled={!getPermissions(entity).edit}/>
                </Col>
            </Row>
        </TableCard>
}


export default AdventureView;